import { RESUME_FORM_ACTION_TYPES } from "./types"

const initialState = {
  countries: null,
  states: null,
  cities: null,
  error: null,
  errorUpload: null,
  ResumeInfo: {},
  // resumeUrl: null,
  futureNavigation: null,
  loading: false,
  resumeData: {},
  certificateData: {},
  attachmentData: {}
}

const resumeFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESUME_FORM_ACTION_TYPES.GET_ALL_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload
      }
    case RESUME_FORM_ACTION_TYPES.GET_ALL_COUNTRIES_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case RESUME_FORM_ACTION_TYPES.GET_ALL_STATES_SUCCESS:
      return {
        ...state,
        states: action.payload
      }
    case RESUME_FORM_ACTION_TYPES.GET_ALL_STATES_FAIL:
      return {
        ...state,
        error: action.payload
      }
    case RESUME_FORM_ACTION_TYPES.GET_ALL_CITIES_SUCCESS:
      return {
        ...state,
        cities: action.payload
      }
    case RESUME_FORM_ACTION_TYPES.GET_ALL_CITIES_FAIL:
      return {
        ...state,
        error: action.payload
      }

    case RESUME_FORM_ACTION_TYPES.POST_RESUME_FORM_REQUEST:
      return {
        ...state,
        loading: true
      }

    case RESUME_FORM_ACTION_TYPES.POST_RESUME_FORM_SUCCESS:
      return {
        ...state,
        ResumeInfo: action.payload,
        loading: false
      }
    case RESUME_FORM_ACTION_TYPES.POST_RESUME_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case RESUME_FORM_ACTION_TYPES.UPLOAD_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        errorUpload: null
      }

    case RESUME_FORM_ACTION_TYPES.UPLOAD_RESUME_SUCCESS:
      // localStorage.setItem(
      //   "currAiCategorizeLimit",
      //   action.payload?.apiCallLimit?.current
      //     ? action.payload?.apiCallLimit?.current
      //     : localStorage.getItem("currAiCategorizeLimit") > 0
      //     ? localStorage.getItem("currAiCategorizeLimit") - 1
      //     : 0
      // )

      return {
        ...state,
        errorUpload: null,
        resumeData: action.payload,
        loading: false
      }
    case RESUME_FORM_ACTION_TYPES.UPLOAD_RESUME_FAIL:
      return {
        ...state,
        errorUpload: action.payload,
        loading: false
      }
    case RESUME_FORM_ACTION_TYPES.REMOVE_RESUME_URL:
      return {
        ...state,
        resumeUrl: null,
        loading: false,
        resumeData: {}
      }

    case RESUME_FORM_ACTION_TYPES.CLEAR_RESUME_FORM:
      return {
        ...state,
        ResumeInfo: {},
        resumeUrl: null
      }

    case RESUME_FORM_ACTION_TYPES.FUTURE_NAVIGATION:
      return {
        ...state,
        futureNavigation: action.payload
      }

    case RESUME_FORM_ACTION_TYPES.UPLOAD_CERTIFICATE_REQUEST:
      return {
        ...state,
        loading: true,
        errorUpload: null
      }

    case RESUME_FORM_ACTION_TYPES.UPLOAD_CERTIFICATE_SUCCESS:
      return {
        ...state,
        loading: false,
        errorUpload: null,
        certificateData: {
          ...(state.certificateData || {}),
          [action.payload.index]: action.payload.response
        }
      }

    case RESUME_FORM_ACTION_TYPES.UPLOAD_CERTIFICATE_FAIL:
      return {
        ...state,
        loading: false,
        errorUpload: {
          ...(state.errorUpload || {}),
          [action.payload.index]: action.payload.error
        }
      }

    case RESUME_FORM_ACTION_TYPES.UPLOAD_ATTACHMENT_REQUEST:
      return {
        ...state,
        loading: true,
        errorUpload: null
      }
    case RESUME_FORM_ACTION_TYPES.UPLOAD_ATTACHMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        errorUpload: null,
        attachmentData: {
          ...(state.attachmentData || {}),
          [action.payload.index]: action.payload.response
        }
      }
    case RESUME_FORM_ACTION_TYPES.UPLOAD_ATTACHMENT_FAIL:
      return {
        ...state,
        loading: false,
        errorUpload: {
          ...(state.errorUpload || {}),
          [action.payload.index]: action.payload.error
        }
      }
      
    case RESUME_FORM_ACTION_TYPES.REMOVE_CERTIFICATE_URL:
      return {
        ...state,
        certificateData: {},
        loading: false
      }

    case RESUME_FORM_ACTION_TYPES.REMOVE_ATTACHMENT_URL:
      return {
        ...state,
        attachmentData: {},
        loading: false
      }

    default:
      return state
  }
}

export default resumeFormReducer
